import { IS_NO_IP_ONLY_HTTPS } from 'constants/constants';
import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

export const footerSchema = yup.object().shape({
  appstoreLink: yup
    .string()
    .test(
      'Must be a valid URL, starting with https://, and not an IP address',
      'Must be a valid URL, starting with https://, and not an IP address',
      (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
    ),
  googlePlayLink: yup
    .string()
    .test(
      'Must be a valid URL, starting with https://, and not an IP address',
      'Must be a valid URL, starting with https://, and not an IP address',
      (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
    ),
  privacyPolicyUrl: yup
    .string()
    .required(required('Privacy Policy'))
    .test(
      'Must be a valid URL, starting with https://, and not an IP address',
      (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
    ),
  termsAndConditionsUrl: yup
    .string()
    .required(required('Terms and Conditions'))
    .test(
      'Must be a valid URL, starting with https://, and not an IP address',
      (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
    ),
  supportLink: yup
    .string()
    .test(
      'Must be a valid URL, starting with https://, and not an IP address',
      'Must be a valid URL, starting with https://, and not an IP address',
      (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
    ),
  supportParams: yup
    .object()
    .shape({
      playerIdParamName: yup
        .string()
        .test(
          'param-name',
          'Use only letters, numbers, underscores, and hyphens',
          (value) =>
            value === undefined ||
            value === '' ||
            /^[a-zA-Z0-9_-]+$/.test(value as string)
        ),
      playerNameParamName: yup
        .string()
        .test(
          'param-name',
          'Use only letters, numbers, underscores, and hyphens',
          (value) =>
            value === undefined ||
            value === '' ||
            /^[a-zA-Z0-9_-]+$/.test(value as string)
        )
    })
    .notRequired(),
  openLinksInNewTab: yup.boolean(),
  showCookieSettings: yup.boolean()
});

export const generalEssentialsSchema = yup.object().shape({
  storeTabName: yup.string().required(required('Store Tab Title')),
  loaderAnimation: yup.string(),
  defaultPlayerImage: yup.string(),
  favicon: yup.string().required(required('Favicon')),
  storeSaleImage: yup.string()
});

export const storeOrientationSchema = yup.object().shape({
  showRotatePrompt: yup.boolean()
});

export const emptyStateSchema = yup.object().shape({
  noOffersTitleText: yup.string(),
  noOffersMessageText: yup.string()
});

export const getSeoSchema = (isStoreSEOEnabled: boolean) =>
  yup.object().shape({
    title: isStoreSEOEnabled
      ? yup
          .string()
          .max(60, 'Title must be 60 characters or less')
          .required(required('SEO Title'))
      : yup
          .string()
          .max(60, 'Title must be 60 characters or less')
          .notRequired(),
    description: isStoreSEOEnabled
      ? yup
          .string()
          .max(160, 'Description must be 160 characters or less')
          .required(required('SEO Description'))
      : yup
          .string()
          .max(160, 'Description must be 160 characters or less')
          .notRequired(),
    keywords: yup.array().of(yup.string()).notRequired(),
    socialShareImageUrl: yup.string().notRequired(),
    socialTitle: yup
      .string()
      .max(60, 'Social Title must be 60 characters or less')
      .notRequired(),
    socialDescription: yup
      .string()
      .max(160, 'Social Description must be 160 characters or less')
      .notRequired()
  });

export const maintenanceSchema = yup.object().shape({
  maintenanceModeRichText: yup
    .object()
    .shape({
      text: yup.string(),
      fontColor: yup.string()
    })
    .notRequired()
});

export const storeSectionsSchema = yup.object().shape({
  bundleSections: yup.array().default([]),
  promotionSections: yup.array().default([])
});

export const storeTabsSchema = yup.object().shape({
  tabs: yup.array().default([])
});
